import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext'; // CORRIGIDO
import { useEntidadeContext } from '../../EntidadeContext';
import { Button, Form, Card, Modal, Spinner, Table, Row, Col, Alert } from 'react-bootstrap';
import axios from 'axios';
import InputMask from 'react-input-mask';


const OnboardingCollaboratorsPage = () => {
    const navigate = useNavigate();
    const { completeOnboardingStep } = useAuthContext();
    const { currentEntidade } = useEntidadeContext();

    const [showColaboradorModal, setShowColaboradorModal] = useState(false);
    const [isLoadingColaborador, setIsLoadingColaborador] = useState(false);
    const [colaboradorSubmitMessage, setColaboradorSubmitMessage] = useState(null);
    const [novoColaboradorData, setNovoColaboradorData] = useState({
        nome: '',
        cpf: '',
        email: '',
        setor_id: '',
        cargo_id: '',
        standard_role_id: null, // Para perfis padrão
        tipo_contrato: 'CLT', // Adicionado campo obrigatório
        entidade_perfil_id: null, // Para perfis customizados
        telefoneCompleto: '', // Novo campo unificado para a máscara
        dddcelular: '',
        celular: '',
        especialidade_id: null,
    });
    const [colaboradoresAdicionados, setColaboradoresAdicionados] = useState([]);

    const [setores, setSetores] = useState([]);
    const [cargosDoSetor, setCargosDoSetor] = useState([]);
    const [perfis, setPerfis] = useState([]);
    const [isLoadingCargos, setIsLoadingCargos] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [isProfileSelectDisabled, setIsProfileSelectDisabled] = useState(false);

    const NOME_SETOR_CORPO_CLINICO = 'Corpo Clínico';
    const NOME_PERFIL_MEDICO = 'Médico';
    // Estados para armazenar os objetos encontrados
    const [corpoClinicoSetor, setCorpoClinicoSetor] = useState(null);
    const [perfilMedicoEncontrado, setPerfilMedicoEncontrado] = useState(null);

    const fetchSetores = useCallback(async () => {
        if (currentEntidade?.id) {
            try {
                const response = await axios.get(`/api/setores?entidade_id=${currentEntidade.id}`);
                setSetores(response.data.setores || []);
            } catch (error) {
                console.error("Erro ao buscar setores:", error);
                setColaboradorSubmitMessage({ type: 'danger', text: 'Erro ao carregar setores.' });
            }
        }
    }, [currentEntidade]);

    const fetchCargosPorSetor = useCallback(async (setorId) => {
        if (setorId && currentEntidade?.id) {
            setIsLoadingCargos(true);
            try {
                const response = await axios.get(`/api/setores/${setorId}/cargos?entidade_id=${currentEntidade.id}`);
                setCargosDoSetor(response.data.cargos || []);
            } catch (error) {
                console.error("Erro ao buscar cargos:", error);
                setCargosDoSetor([]);
                setColaboradorSubmitMessage({ type: 'danger', text: 'Erro ao carregar cargos.' });
            } finally {
                setIsLoadingCargos(false);
            }
        } else {
            setCargosDoSetor([]);
        }
    }, [currentEntidade]);

    const fetchPerfis = useCallback(async () => {
        if (currentEntidade?.id) {
            try {
                const response = await axios.get(`/api/perfis?entidade_id=${currentEntidade.id}`);
                setPerfis(response.data.perfis || []);
            } catch (error) {
                console.error("Erro ao buscar perfis:", error);
                setColaboradorSubmitMessage({ type: 'danger', text: 'Erro ao carregar perfis de acesso.' });
            }
        }
    }, [currentEntidade]);

    const fetchEspecialidades = useCallback(async () => {
        if (currentEntidade?.id) {
            try {
                const response = await axios.get(`/api/especialidades?entidade_id=${currentEntidade.id}`);
                setEspecialidades(response.data.especialidades || []);
            } catch (error) {
                console.error("Erro ao buscar especialidades:", error);
                // Considerar adicionar uma mensagem de erro para o usuário se necessário
            }
        }
    }, [currentEntidade]);

    // Carrega setores e perfis uma vez
    useEffect(() => {
        const carregarDadosIniciais = async () => {
            if (currentEntidade?.id) {
                // Usar um estado de loading geral se preferir
                // setIsLoadingColaborador(true); 
                try {
                    const [setoresRes, perfisRes, especialidadesRes] = await Promise.all([
                        axios.get(`/api/setores?entidade_id=${currentEntidade.id}`),
                        axios.get(`/api/perfis?entidade_id=${currentEntidade.id}`)
                    ]);

                    const fetchedSetores = setoresRes.data.setores || [];
                    setSetores(fetchedSetores);
                    const ccSetor = fetchedSetores.find(s => s.nome === NOME_SETOR_CORPO_CLINICO);
                    setCorpoClinicoSetor(ccSetor);

                    const fetchedPerfis = perfisRes.data.perfis || [];
                    setPerfis(fetchedPerfis);
                    const medPerfil = fetchedPerfis.find(p => p.tipo === 'padrao' && p.nome === NOME_PERFIL_MEDICO);
                    setPerfilMedicoEncontrado(medPerfil);

                    // Fetch especialidades também
                    fetchEspecialidades();

                    if (!ccSetor) {
                        setColaboradorSubmitMessage({ type: 'warning', text: 'Setor "Corpo Clínico" não encontrado. Verifique as configurações da entidade.' });
                    }
                    if (!medPerfil) {
                        setColaboradorSubmitMessage({ type: 'warning', text: 'Perfil "Médico" não encontrado. Verifique as configurações da entidade.' });
                    }

                } catch (error) {
                    console.error("Erro ao buscar dados iniciais (setores/perfis):", error);
                    setColaboradorSubmitMessage({ type: 'danger', text: 'Erro ao carregar configurações iniciais para colaboradores.' });
                } finally {
                    // setIsLoadingColaborador(false);
                }
            }
        };
        carregarDadosIniciais();
    }, [currentEntidade, NOME_SETOR_CORPO_CLINICO, NOME_PERFIL_MEDICO, fetchEspecialidades]);

    // useEffect para definir automaticamente o setor, perfil e carregar cargos
    useEffect(() => {
        if (showColaboradorModal) {
            if (corpoClinicoSetor && perfilMedicoEncontrado) {
                setIsProfileSelectDisabled(true); // Oculta o select de perfil
                setNovoColaboradorData(prev => ({
                    ...prev,
                    setor_id: corpoClinicoSetor.id,
                    standard_role_id: perfilMedicoEncontrado.id,
                    entidade_perfil_id: null
                }));
                fetchCargosPorSetor(corpoClinicoSetor.id);
            } else {
                // Se Corpo Clínico ou Médico não encontrados, impede a lógica normal.
                setIsProfileSelectDisabled(true); // Mantém oculto para não confundir
                let errorMsg = '';
                if (!corpoClinicoSetor) errorMsg += 'Setor "Corpo Clínico" não configurado. ';
                if (!perfilMedicoEncontrado) errorMsg += 'Perfil "Médico" não configurado.';
                setColaboradorSubmitMessage(prev => ({
                    type: 'danger',
                    text: prev?.text ? prev.text + " " + errorMsg : errorMsg
                }));
                setNovoColaboradorData(prev => ({ // Limpa para evitar envio incorreto
                    ...prev,
                    setor_id: '',
                    standard_role_id: null,
                    entidade_perfil_id: null
                }));
                setCargosDoSetor([]); // Limpa cargos
            }
        }
    }, [showColaboradorModal, corpoClinicoSetor, perfilMedicoEncontrado, fetchCargosPorSetor]);


    const resetNovoColaboradorForm = () => {
        setNovoColaboradorData({
            nome: '', cpf: '', email: '',
            setor_id: '', 
            cargo_id: '', tipo_contrato: 'CLT',
            standard_role_id: null, entidade_perfil_id: null, especialidade_id: null,
            telefoneCompleto: '', dddcelular: '', celular: ''
        });
        setCargosDoSetor([]);
        // Se o setor "Corpo Clínico" e o perfil "Médico" foram encontrados,
        // o select de perfil deve permanecer desabilitado (oculto) mesmo após o reset,
        // pois ainda estamos no contexto de adicionar médicos.
        // Se não foram encontrados, o comportamento padrão é permitir a seleção (embora o botão de salvar ficaria desabilitado).
        setIsProfileSelectDisabled(!!(corpoClinicoSetor && perfilMedicoEncontrado));    };

    const handleOpenColaboradorModal = () => {
        resetNovoColaboradorForm();
        setColaboradorSubmitMessage(null); // Limpa mensagens de erro/sucesso anteriores
        // O useEffect acima cuidará de setar setor_id, perfil_id e buscar cargos
        // quando showColaboradorModal se tornar true.
        setShowColaboradorModal(true);
    };
    const handleCloseColaboradorModal = () => setShowColaboradorModal(false);

    const handleColaboradorInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'telefoneCompleto') {
            const apenasNumeros = value.replace(/\D/g, '');
            const ddd = apenasNumeros.substring(0, 2);
            const celular = apenasNumeros.substring(2);

            // Atualiza tanto o campo da máscara quanto os campos separados
            setNovoColaboradorData(prev => ({ ...prev, telefoneCompleto: value, dddcelular: ddd, celular: celular }));
        } else {
            setNovoColaboradorData(prev => ({ ...prev, [name]: value }));
        }
    };

    // handleSetorChange não é mais necessário

    const handleAddColaborador = async (e) => {
        e.preventDefault();
        setIsLoadingColaborador(true);
        setColaboradorSubmitMessage(null);

        if (!currentEntidade?.id) {
            setColaboradorSubmitMessage({ type: 'danger', text: 'Entidade não identificada.' });
            setIsLoadingColaborador(false);
            return;
        }
        // Validação adicional para garantir que setor e perfil foram definidos
        if (!novoColaboradorData.setor_id || (!novoColaboradorData.standard_role_id && !novoColaboradorData.entidade_perfil_id)) {
             setColaboradorSubmitMessage({ type: 'danger', text: 'Configuração de setor/perfil pendente. Verifique as mensagens de alerta.' });
             setIsLoadingColaborador(false);
             return;
        }

        const payload = {
            ...novoColaboradorData,
            cpf: novoColaboradorData.cpf.replace(/\D/g, ''), // Remove a máscara antes de enviar
            entidade_id: currentEntidade.id,
            password: '12345678',
            password_confirmation: '12345678',
        };

        try {
            const response = await axios.post('/api/funcionarios', payload);
            setColaboradoresAdicionados(prev => [...prev, response.data.funcionario]);
            setColaboradorSubmitMessage({ type: 'success', text: `Médico "${response.data.funcionario.nome}" adicionado com sucesso!` });
            resetNovoColaboradorForm(); // Limpa para o próximo
            handleCloseColaboradorModal(); // Fecha o modal
        } catch (error) {
            console.error("Erro ao adicionar médico:", error.response?.data || error.message);
            setColaboradorSubmitMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao adicionar médico.' });
        } finally {
            setIsLoadingColaborador(false);
        }
    };

    const handleCompleteStep = async () => {
        try {
            const result = await completeOnboardingStep('collaborators'); 

            if (result.onboarding_complete) {
                navigate('/dashboard');
            } else if (result.next_step_key === 'pending_materials') {
                navigate('/onboarding/materials');
            } else {
                navigate('/dashboard'); 
            }
        } catch (error) {
            console.error("Erro ao completar passo de colaboradores:", error.response?.data || error.message);
            alert(`Erro ao finalizar esta etapa: ${error.response?.data?.message || error.message}`);
        }
    };

    return (
        <Card className="p-4">
            <Card.Body>
                <Card.Title as="h2" className="text-center mb-4">Etapa 3: Cadastrar Equipe (Médicos)</Card.Title>
                <p className="text-center">Adicione pelo menos um médico da sua equipe para que você possa prosseguir. Você poderá adicionar mais depois.</p>
                <div className="d-grid gap-2 mb-4">
                    <Button variant="primary" onClick={handleOpenColaboradorModal} disabled={!corpoClinicoSetor || !perfilMedicoEncontrado}>
                        Adicionar Novo Médico
                    </Button>
                </div>

                {(!corpoClinicoSetor || !perfilMedicoEncontrado) && !isLoadingColaborador && (
                     <Alert variant="warning" className="mt-2">
                        Configuração inicial pendente:
                        {!corpoClinicoSetor && " Setor 'Corpo Clínico' não encontrado. "}
                        {!perfilMedicoEncontrado && " Perfil 'Médico' não encontrado. "}
                        Verifique as configurações da entidade antes de adicionar médicos.
                    </Alert>
                )}

                {colaboradoresAdicionados.length > 0 && (
                    <>
                        <h5 className="mt-4">Médicos Adicionados:</h5>
                        <Table striped bordered hover responsive size="sm">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {colaboradoresAdicionados.map((col) => (
                                    <tr key={col.id}>
                                        <td>{col.nome}</td>
                                        <td>{col.email}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </>
                )}

                <Modal show={showColaboradorModal} onHide={handleCloseColaboradorModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Adicionar Novo Médico</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {colaboradorSubmitMessage && (
                            <Alert variant={colaboradorSubmitMessage.type} onClose={() => setColaboradorSubmitMessage(null)} dismissible>
                                {colaboradorSubmitMessage.text}
                            </Alert>
                        )}
                        <Alert variant="info">
                            A senha padrão para o primeiro acesso será <strong>12345678</strong>. O usuário poderá alterá-la após o login.
                        </Alert>
                        <Form onSubmit={handleAddColaborador}>
                            {/* Campo Setor removido */}
                            <Form.Group className="mb-3" controlId="onboardingColabCargo">
                                <Form.Label>Cargo *</Form.Label>
                                <Form.Select 
                                    name="cargo_id" 
                                    value={novoColaboradorData.cargo_id} 
                                    onChange={handleColaboradorInputChange} 
                                    required 
                                    disabled={!corpoClinicoSetor?.id || isLoadingCargos}
                                >
                                    <option value="">
                                        {isLoadingCargos ? 'Carregando...' : (corpoClinicoSetor?.id ? 'Selecione um Cargo' : 'Setor Corpo Clínico não configurado')}
                                    </option>
                                    {cargosDoSetor.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="onboardingColabTipoContrato">
                                <Form.Label>Tipo de Contrato *</Form.Label>
                                <Form.Select 
                                    name="tipo_contrato" 
                                    value={novoColaboradorData.tipo_contrato} 
                                    onChange={handleColaboradorInputChange} required>
                                    <option value="CLT">CLT</option>
                                    <option value="PJ">PJ</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="onboardingColabNome"><Form.Label>Nome Completo *</Form.Label><Form.Control type="text" name="nome" value={novoColaboradorData.nome} onChange={handleColaboradorInputChange} required /></Form.Group>
                            
                            {novoColaboradorData.cargo_id && especialidades.filter(e => e.cargo_id === parseInt(novoColaboradorData.cargo_id)).length > 0 && (
                                <Form.Group className="mb-3" controlId="onboardingColabEspecialidade">
                                    <Form.Label>Especialidade</Form.Label>
                                    <Form.Select 
                                        name="especialidade_id" 
                                        value={novoColaboradorData.especialidade_id || ''} 
                                        onChange={handleColaboradorInputChange}
                                    >
                                        <option value="">Selecione uma Especialidade</option>
                                        {especialidades.filter(e => e.cargo_id === parseInt(novoColaboradorData.cargo_id)).map(e => (
                                            <option key={e.id} value={e.id}>{e.nome}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            )}
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="onboardingColabCpf">
                                        <Form.Label>CPF *</Form.Label>
                                        <InputMask mask="999.999.999-99" value={novoColaboradorData.cpf} onChange={handleColaboradorInputChange} name="cpf">
                                            {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                        </InputMask>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3" controlId="onboardingColabTelefone"><Form.Label>Celular (com DDD) *</Form.Label><InputMask mask="(99) 99999-9999" value={novoColaboradorData.telefoneCompleto} onChange={handleColaboradorInputChange} name="telefoneCompleto">{(inputProps) => <Form.Control {...inputProps} type="tel" required />}</InputMask></Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}><Form.Group className="mb-3" controlId="onboardingColabEmail"><Form.Label>Email *</Form.Label><Form.Control type="email" name="email" value={novoColaboradorData.email} onChange={handleColaboradorInputChange} required /></Form.Group></Col>
                            </Row>

                            {/* O select de Perfil de Acesso é ocultado porque isProfileSelectDisabled será true */}
                            {!isProfileSelectDisabled && (
                                <Form.Group className="mb-3" controlId="onboardingColabPerfil">
                                    <Form.Label>Perfil de Acesso *</Form.Label>
                                    <Form.Select name="perfil_unificado_id" value={novoColaboradorData.entidade_perfil_id || novoColaboradorData.standard_role_id || ''} 
                                        onChange={(e) => {
                                            const perfilId = e.target.value;
                                            const perfilSelecionado = perfis.find(p => p.id.toString() === perfilId);
                                            if (perfilSelecionado) {
                                                setNovoColaboradorData(prev => ({ ...prev, standard_role_id: perfilSelecionado.tipo === 'padrao' ? perfilSelecionado.id : null, entidade_perfil_id: perfilSelecionado.tipo === 'customizado' ? perfilSelecionado.id : null }));
                                            } else {
                                                setNovoColaboradorData(prev => ({ ...prev, standard_role_id: null, entidade_perfil_id: null }));
                                            }
                                        }} required>
                                        <option value="">Selecione um Perfil</option>
                                        {perfis.filter(p => !(p.tipo === 'padrao' && p.key === 'representante_legal')).map(p => <option key={p.id} value={p.id}>{p.nome} ({p.tipo === 'padrao' ? 'Padrão' : 'Customizado'})</option>)}
                                    </Form.Select>
                                </Form.Group>
                            )}
                            <div className="d-flex justify-content-end mt-3">
                                <Button variant="secondary" onClick={handleCloseColaboradorModal} className="me-2" disabled={isLoadingColaborador}>Fechar</Button>
                                <Button 
                                    variant="primary" 
                                    type="submit" 
                                    disabled={isLoadingColaborador || !corpoClinicoSetor?.id || !perfilMedicoEncontrado?.id}
                                >
                                    {isLoadingColaborador ? <Spinner as="span" animation="border" size="sm" /> : 'Salvar Médico'}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Button variant="success" onClick={handleCompleteStep} className="w-100 mt-3" disabled={colaboradoresAdicionados.length === 0}>
                    Concluir Configuração e Ir para o Painel
                </Button>
            </Card.Body>
        </Card>

    );
};

export default OnboardingCollaboratorsPage;